import { head } from 'ramda';

import sortPromotionCodes from '../sortPromotionCodes';

export const getCampaignCodesFromSegments = (flightSegments) =>
  (flightSegments &&
    flightSegments.map((flight) => flight.promotionCode || '')) ||
  [];

const getCampaignCodeFromSegments = (flightSegments, campaignPills) => {
  const promotionCodes = getCampaignCodesFromSegments(flightSegments);

  const sortedCodes = sortPromotionCodes(promotionCodes, campaignPills);
  return head(sortedCodes) || '';
};

export default getCampaignCodeFromSegments;
